<section class="result-table m-flex m-flex-column m-gap:2">
  <div class="result-table__sheet m-overflow:auto">
    <myre-sheet [content]="_sheet()" [displayRowNumbers]="true" />
  </div>

  <footer class="m-flex m-flex-column m-gap:1">
    <div class="m-flex m-gap:2 m-flex-items:center">
      <span class="m-text-body:small m-text-color:neutral">
        {{ _rows().length }} / {{ result().rowCount }}
        {{ chatWordings.citationRows() }}
      </span>

      @if (_hasMore()) {
        <button
          class="result-table__more"
          type="button"
          [disabled]="_loading()"
          (click)="loadMore()"
        >
          {{ _loading() ? chatWordings.loading() : chatWordings.expand() }}
        </button>
      }

      @if (_failed()) {
        <span class="m-text-body:small m-text-color:error">
          {{ chatWordings.somethingWentWrong() }}
        </span>
      }
    </div>

    <p class="result-table__perimeter m-text-body:small m-text-color:neutral">
      {{ result().perimeterLine }}
    </p>
  </footer>
</section>
